module.exports = __webpack_public_path__ + "img/fondoopacity3.27445524.png";